<ng-template #settingsTemplate>
    <app-tool-setting label="Lengte getallenlijn">
        <div class="options-grid">
            @for (option of numberLineOptions; track option) {
            <app-radio-input
                [value]="option[0] + '_' + option[1]"
                [model]="length"
                (selected)="length = $event"
            >
                {{ option[0] }} - {{ option[1] }}
            </app-radio-input>
            }
        </div>
    </app-tool-setting>
    <app-tool-setting label="Getallen/streepjes op getallenlijn">
        <div class="options-grid">
            <app-check-box
                label="Getallen"
                [checked]="showNumbers"
                (checkedChange)="showNumbers = $event"
            ></app-check-box>
            <app-check-box
                label="Eenheden"
                [checked]="showUnits"
                (checkedChange)="showUnits = $event"
            ></app-check-box>
            <app-check-box
                label="Getallenstreepjes"
                [checked]="showMarkers"
                (checkedChange)="showMarkers = $event"
            ></app-check-box>
        </div>
    </app-tool-setting>
    <app-tool-setting label="Label">
        <app-svg-input [options]="svgList" [parent]="instance"></app-svg-input>
    </app-tool-setting>
</ng-template>
<ng-template #contentTemplate>
    <app-line-svg
        [length]="length"
        [showMarkers]="showMarkers"
        [showNumbers]="showNumbers"
        [showUnits]="showUnits"
    ></app-line-svg>
</ng-template>
